<script setup>
import { message } from 'ant-design-vue';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { onBeforeMount, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import TwentythreeLogoWhite from '../assets/img/TwentythreeLogo-white.png';
import { useAdminStore } from '../stores/admin';

const AdminStore = useAdminStore()
const $router = useRouter()
onBeforeMount(() => {
  const auth = getAuth()
  onAuthStateChanged(auth, user => {
    if(user) AdminStore.saveUser(user)
    else {
      $router.replace('/login')
    }
  })
})

const $route = useRoute()
const ROUTER_NAME = ['admin-dashboard', 'admin-clothe', 'admin-insert']
const selectedKeys = ref([])
onMounted(() => {
  selectedKeys.value = [`${ROUTER_NAME.indexOf($route.name)+1}`]
})

const logout = async () => {
  const { state } = await AdminStore.signOut()
  if (state === 'SUCCESS'){
    message.success('已登出')
    $router.replace('/login')
  }
}
</script>

<template>
  <a-layout id="view-admin">
    <a-layout-header class="header">
      <div class="logo">
        <img :src="TwentythreeLogoWhite" alt="">
        <h2>二拾衫收衣系統後台</h2>
      </div>
      <div class="current-admin">
        <h4>操作人員：{{ AdminStore.currentAccount?.email }}</h4>
        <a-button @click="logout">登出</a-button>
      </div>
    </a-layout-header>
  <a-layout>
      <a-layout-sider width="200" style="background: #fff">
        <a-menu
          v-model:selectedKeys="selectedKeys"
          mode="inline"
          :style="{ height: '100%', borderRight: 0 }"
        >
        <a-menu-item key="1"><router-link to="/admin/">使用者資料</router-link></a-menu-item>
        <a-menu-item key="2"><router-link to="/admin/clothe">衣物案件資料</router-link></a-menu-item>
        <a-menu-item key="3"><router-link to="/admin/insert">匯入 Google 試算表資料</router-link></a-menu-item>
        </a-menu>
      </a-layout-sider>
      <a-layout style="padding: 0 24px 24px">
        <a-breadcrumb style="margin: 16px 0"></a-breadcrumb>
        <a-layout-content
          :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px' }"
        >
          <router-view></router-view>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>
